// src/components/StatusBadge.tsx — Reusable status pill component
import { statusMeta } from '../utils/formatters'

export function StatusBadge({ status }: { status: string }) {
  const s = statusMeta(status)
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${s.bg} ${s.text}`}>
      {s.label}
    </span>
  )
}
